<template>
  <div class="kpis-tab">
    <KPIsTable
      :kpis="kpis"
      :page="page"
      :perPage="perPage"
      :totalCount="totalCount"
      :currencies="currencies"
      :hiddenMenuActions="hiddenMenuActions"
      :initialSearchText="initialSearchText"
      @onButtonAction="handleButtonAction"
      @onSearch="handleSearch"
      @onFilter="handleFilter"
      @removeFilter="handleRemoveFilter"
      @checkedItemsChanged="handleCheckedItemsChanged"
      @page-change="handlePageChange"
      @add-kpi="handleAddKPI"
      @clear-search="handleClearSearch"
      @openChatter="handleOpenChatter"
      @menu-action="handleMenuAction"
    />
    <AddKPIDialog
      v-if="addKpiEnabled"
      v-model="showAddKpiDialog"
      @created="handleKpiCreated"
    />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import KPIsTable from "@components/KPIsTable/KPIsTable.vue";
import AddKPIDialog from "@components/AddKPIDialog/AddKPIDialog.vue";
import { LD_FLAG_IDEA_MDP_428 } from "@components/constants/launchDarklyFlagKeys";
import launchDarklyService from "@/services/launchdarkly";

const props = defineProps({
  kpis: {
    type: Array,
    default: () => [],
  },
  page: {
    type: Number,
    default: 1,
  },
  perPage: {
    type: Number,
    default: 25,
  },
  totalCount: {
    type: Number,
    default: null,
  },
  currencies: {
    type: Array,
    default: () => [],
  },
  hiddenMenuActions: {
    type: Array,
    default: () => [],
  },
  initialSearchText: {
    type: String,
    default: "",
  },
});

const emit = defineEmits([
  "onButtonAction",
  "onSearch",
  "onFilter",
  "removeFilter",
  "checkedItemsChanged",
  "page-change",
  "add-kpi",
  "clear-search",
  "openChatter",
  "menu-action",
  "kpi-created",
]);

const addKpiEnabled = ref(false);
const showAddKpiDialog = ref(false);

onMounted(async () => {
  addKpiEnabled.value = await launchDarklyService.getFlag(LD_FLAG_IDEA_MDP_428, false);
});

const openAddKpiDialog = () => {
  showAddKpiDialog.value = addKpiEnabled.value;
};

const handleKpiCreated = (kpi) => {
  emit("kpi-created", kpi);
};

const handleButtonAction = (action) => {
  if (action === "add") {
    openAddKpiDialog();
  }
  emit("onButtonAction", action);
};

const handleSearch = (searchValue) => {
  emit("onSearch", searchValue);
};

const handleFilter = () => {
  emit("onFilter");
};

const handleRemoveFilter = (filter) => {
  emit("removeFilter", filter);
};

const handleCheckedItemsChanged = (filters) => {
  emit("checkedItemsChanged", filters);
};

const handlePageChange = (page) => {
  emit("page-change", page);
};

const handleAddKPI = () => {
  openAddKpiDialog();
  emit("add-kpi");
};

const handleClearSearch = () => {
  emit("clear-search");
};

const handleOpenChatter = (rowData) => {
  emit("openChatter", rowData);
};

const handleMenuAction = (payload) => {
  emit("menu-action", payload);
};
</script>

<style scoped>
.kpis-tab {
  width: 100%;
}
</style>

